<template>
    <a
        :class="[
            'art-poster-container',
            className,
            { isDisabled: isExpired },
        ]"
        :href="contentData.fields.linkUrl"
        data-spm-data="p"
        :data-spm-content="`||${this.uuid}||`"
        @click="sendAction(8886, $event)"
    >
        <div :class="['art-poster-info', 'type35']" v-if="insertType == 35 || insertType == 64">
            <div class="left">
                <div class="title">{{ contentData.cardName }}</div>
                <div class="poster-info" v-if="contentData.fields.desc">
                    {{ contentData.fields.desc }}
                </div>
            </div>
            <div class="art-insert-container">
                <span
                    class="link-btn"
                    v-if="
                        contentData.fields.btnText && !isExpired
                    "
                    >{{ contentData.fields.btnText }}</span
                >
            </div>
        </div>
        <img class="art-poster-img" :src="contentData.fields.image" />
        <div class="art-poster-info type36" v-if="insertType == 36 || insertType == 65">
            <div class="left">
                <div class="title">{{ contentData.cardName }}</div>
                <div class="poster-info" v-if="contentData.fields.desc">
                    {{ contentData.fields.desc }}
                </div>
            </div>
            <div class="art-insert-container">
                <span
                    class="link-btn"
                    v-if="
                        contentData.fields.btnText && !isExpired
                    "
                    >{{ contentData.fields.btnText }}</span
                >
            </div>
        </div>
        <card-bottom :data="contentData"></card-bottom>
    </a>
</template>

<style lang="less" scoped>
@import "../../../less/base/mixins.less";
.art-poster-container {
    display: block;
    background: #ffffff;
    margin-bottom: 40px;
    .art-poster-info {
        display: flex;
        padding: 22px 24px 20px 24px;
        align-items: center;
        border: 1px solid rgba(229, 229, 229, 1);
        .left {
            width: 410px;
            .title {
                font-family: PingFang SC;
                font-weight: 500;
                color: #3c3c3d;
                line-height: 42px; /*px*/
                font-size: 32px; /*px*/
                .line-clamp(2);
                overflow: hidden;
            }
            .poster-info {
                margin-top: 16px; /*px*/
                font-size: 22px; /*px*/
                color: #a4a4a4;
                line-height: 32px; /*px*/
                height: 32px; /*px*/
                text-overflow: ellipsis;
                white-space: nowrap;
                overflow: hidden;
            }
        }
        .link-btn {
            display: inline-flex;
            padding: 16px 36px;
            background: rgba(245, 245, 245, 1);
            border-radius: 56px; /*px*/
            justify-content: center;
            align-items: center;
            margin-left: 32px;
            font-size: 26px !important; /*px*/
            font-family: PingFang SC;
            font-weight: bold;
            color: rgba(249, 74, 37, 1);
            line-height: 36px; /*px*/
        }
    }
    .art-poster-img {
        width: 100% !important;
        height: 391px !important;
        margin-bottom: 0 !important;
    }
    .type35 {
        border-bottom: none;
    }
    .type36 {
        border-top: none;
    }
}
.isDisabled {
    opacity: 0.5;
}
</style>

<script>
import cardBottom from "./../common/cardBottom.vue";
export default {
    data() {
        return {};
    },
    components: {
        cardBottom,
    },
    computed: {
        contentData() {
            return this.articleData;
        },
        className() {
            return this.insertType == 35 || this.insertType == 64 ? "top" : "bottom";
        },
        // 下线&过期状态
        isExpired() {
            const statuslist = [3, 4]
            return statuslist.includes(this.contentData.status) 
        },
    },
    methods: {
        sendAction(acode, e) {
            if (this.isExpired) {
                //阻止默认事件
                e.preventDefault();
                return false;
            }
        },
    },
};
</script>
